import {ImageRequestParams} from "../models/image/image-request-params";
export class PlusImageRequestParams extends ImageRequestParams {
  constructor(width, height, color) {
    super({width, height, color});

    this._resourceName = `bolao24/Icons/Plus_Icon`;
  }
}
